// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"AddInstalmentPaymentModal_modalRoot__21Nvr"};